/* globals CustomFields */
import 'lib/custom_fields'

window['custom_fields#edit'] =
  window['custom_fields#new'] = function () {
    $(document).on('change', 'input#custom_field_for_position', function () {
      const active = $(this).prop('checked')
      $('#position_types input:checkbox').prop('checked', false)
      if (active) {
        $('#position_types').show()
      } else {
        $('#position_types').hide()
      }
    })

    CustomFields.initSelectValues()
  }
